import { render } from "./SecurityContainer.vue?vue&type=template&id=2b5395aa&scoped=true"
import script from "./SecurityContainer.vue?vue&type=script&lang=js"
export * from "./SecurityContainer.vue?vue&type=script&lang=js"

import "./SecurityContainer.vue?vue&type=style&index=0&id=2b5395aa&scoped=true&lang=css"

import exportComponent from "/builds/Xpansiv/evo/DataPipeline/DataPipeline.Evolve.Web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b5395aa"]])

export default __exports__